// extracted by mini-css-extract-plugin
module.exports = {"heading":"_37XVElAyiVgnRwBX8w6e4k","row":"_3y-Ml2ZfOTF3D-NULcpPiP"};